import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { downloadSteps } from '@/mocks/homeData';

export default function AppDownload() {
  const [notice, setNotice] = useState('');

  const handleClick = (platform: string) => {
    setNotice(`${platform} 安装包仅为页面演示，请以官方公布渠道为准`);
    window.setTimeout(() => setNotice(''), 2600);
  };

  return (
    <section id="app" className="w-full scroll-mt-24 border-y border-background-200/70 bg-background-100">
      <div className="mx-auto grid w-full max-w-[1200px] grid-cols-1 items-center gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-2 lg:gap-14">
        <Reveal>
          <div className="relative mx-auto w-full max-w-[420px]">
            <div className="h-[360px] w-full overflow-hidden rounded-lg border border-background-200 bg-background-50 md:h-[440px]">
              <img
                src="https://readdy.ai/api/search-image?query=Minimal%203D%20render%20of%20a%20smartphone%20floating%20at%20a%20slight%20angle%20showing%20a%20blank%20warm%20colored%20app%20interface%2C%20soft%20orange%20and%20cream%20gradient%20backdrop%2C%20clean%20studio%20product%20mockup%2C%20high%20detail&width=900&height=1000&seq=gcg-app-01&orientation=portrait"
                alt="91吃瓜 APP下载指引配图"
                title="91吃瓜 APP下载 官方客户端"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute -right-2 top-6 flex items-center gap-2 rounded-lg border border-background-200 bg-background-50 px-3 py-2 animate-float md:right-0">
              <i className="ri-send-plane-fill text-primary-500" />
              <span className="text-xs font-medium text-foreground-800">加载更快</span>
            </div>
            <div className="absolute -left-2 bottom-8 flex items-center gap-2 rounded-lg border border-background-200 bg-background-50 px-3 py-2 md:left-0">
              <i className="ri-refresh-line text-accent-600" />
              <span className="text-xs font-medium text-foreground-800">账号同步</span>
            </div>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div>
            <span className="text-xs font-label tracking-[0.2em] text-accent-700">APP DOWNLOAD</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">APP下载方式与安装步骤</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              APP 端加载更稳定、支持账号同步；按下面三步操作，几分钟即可完成安装并进场。
            </p>

            <ol className="mt-8 flex flex-col gap-4">
              {downloadSteps.map((item) => (
                <li key={item.step} className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-bold text-background-50">
                    {item.step}
                  </span>
                  <div className="min-w-0">
                    <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  </div>
                </li>
              ))}
            </ol>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <button
                type="button"
                onClick={() => handleClick('安卓')}
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-android-line text-base" />
                安卓下载
              </button>
              <button
                type="button"
                onClick={() => handleClick('iOS')}
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                <i className="ri-apple-line text-base" />
                iOS 下载
              </button>
            </div>

            {notice && (
              <p className="mt-4 inline-flex items-center gap-2 rounded-md border border-accent-200 bg-accent-50 px-3 py-2 text-xs text-accent-800">
                <i className="ri-information-line" />
                {notice}
              </p>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}